import { Link, useLocation, useHistory } from 'react-router-dom';
import { routeConstants } from 'shared/constants';
import SearchBlock from './SearchBlock/SearchBlock';
import { Image } from 'shared/components';
import ProfileSidebar from './ProfileSidebar/ProfileSidebar';
import SearchBlockMobile from './SearchBlock/SearchBlockMobile';
import { useSelector } from 'react-redux';
import { useEffect, useState } from 'react';

const HeaderMid = ({ onLogout, onMobileMenuSwitch }) => {
  const history = useHistory();
  const location = useLocation();
  const cartCount = useSelector((state) => state.cart.cartCount);
  const authUser = useSelector((state) => state.auth.user);
  const [profileMenuVisible, setProfileMenuVisibility] = useState(false);

  const [headerClasses, setHeaderClasses] = useState('header_mid');

  const handleScroll = () => {
    if (window.innerWidth <= 991) {
      const scroll =
        window.pageYOffset !== undefined
          ? window.pageYOffset
          : (
              document.documentElement ||
              document.body.parentNode ||
              document.body
            ).scrollTop;
      if (scroll >= 10) {
        setHeaderClasses('header_mid fixed_mob');
      } else {
        setHeaderClasses('header_mid');
      }
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  useEffect(() => {
    setProfileMenuVisibility(false);
  }, [location]);

  const handleUserImageClicked = (e) => {
    e.preventDefault();

    if (window.innerWidth <= 991) {
      handleProfileSideVisibility(true);
    } else {
      history.push(routeConstants.ACCOUNT.subRoutes.PROFILE.path);
    }
  };

  const handleProfileSideVisibility = (val) => {
    setProfileMenuVisibility(val);
  };

  return (
    <div className={headerClasses} id="middle_header">
      <div className="container">
        <div className="header_mid_body d-flex">
          <div className="left_logo_area">
            <Link to={routeConstants.HOME.path} className="logo">
              <img
                src={require('assets/images/logo.png').default}
                className="img-responsive"
                alt="logo"
              />
            </Link>
            <SearchBlock />
          </div>
          <div className="header_icons_area">
            <ul className="open_acnt">
              {authUser ? (
                <li className="pr-0">
                  <a href="/" onClick={onLogout}>
                    Logout
                  </a>
                </li>
              ) : (
                <>
                  <li>
                    <Link to={routeConstants.AUTH.subRoutes.LOGIN.path}>
                      Login
                    </Link>
                  </li>
                  |
                  <li>
                    <Link to={routeConstants.AUTH.subRoutes.REGISTRATION.path}>
                      register
                    </Link>
                  </li>
                </>
              )}
            </ul>
            <ul className="uer_cart">
              {authUser ? (
                <li className="accnt_img">
                  <a
                    href="/"
                    className="user_img"
                    onClick={handleUserImageClicked}
                  >
                    {authUser.profileImage ? (
                      <Image
                        src={authUser.profileImage.path}
                        alt={authUser.fullName}
                        relativeSrc
                      />
                    ) : (
                      <img
                        src={
                          require('assets/images/profile_images/avatar1.svg')
                            .default
                        }
                        alt={authUser.fullName}
                      />
                    )}
                  </a>
                </li>
              ) : (
                <li className="accnt_img">
                  <Link
                    to={routeConstants.AUTH.subRoutes.LOGIN.path}
                    className="user_img"
                  >
                    <img
                      src={
                        require('assets/images/profile_images/avatar1.svg')
                          .default
                      }
                      alt="user"
                    />
                  </Link>
                </li>
              )}
              <li className="cart_img">
                <Link to={routeConstants.CART.path}>
                  <img
                    src={require('assets/images/cart.png').default}
                    className="userimg"
                    alt="cart"
                  />
                  {!!authUser && (
                    <span className="cart_badge">
                      {cartCount.totalCount || 0}
                    </span>
                  )}
                </Link>
              </li>
              <li className="menu_bar" onClick={onMobileMenuSwitch}>
                <span className="menubar1" />
                <span className="menubar2" />
                <span className="menubar3" />
              </li>
            </ul>
          </div>

          <ProfileSidebar
            onSideMenuClose={() => handleProfileSideVisibility(false)}
            visible={profileMenuVisible}
          />

          <SearchBlockMobile />
        </div>
      </div>
    </div>
  );
};

export default HeaderMid;
